import { ListItem } from "@mui/material";
import DowntimeHelpLink from "./components/DowntimeHelpLink.view";

const DowntimeAppDrawerFooterItems = () => {
    return (
        <>
            <ListItem disablePadding>
                <DowntimeHelpLink />
            </ListItem>
        </>
    );
};

export default DowntimeAppDrawerFooterItems;
